var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.133 9.68335C10.108 9.68335 10.0913 9.68335 10.0663 9.68335C10.0247 9.67502 9.96635 9.67502 9.91635 9.68335C7.49968 9.60835 5.67468 7.70835 5.67468 5.36669C5.67468 2.98335 7.61635 1.04169 9.99968 1.04169C12.383 1.04169 14.3247 2.98335 14.3247 5.36669C14.3163 7.70835 12.483 9.60835 10.158 9.68335C10.1497 9.68335 10.1413 9.68335 10.133 9.68335ZM9.99968 2.29169C8.30802 2.29169 6.92468 3.67502 6.92468 5.36669C6.92468 7.03335 8.22468 8.37502 9.88302 8.43335C9.92468 8.42502 10.0413 8.42502 10.1497 8.43335C11.783 8.35835 13.0663 7.01669 13.0747 5.36669C13.0747 3.67502 11.6913 2.29169 9.99968 2.29169Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1413 18.7916C8.50801 18.7916 6.86634 18.375 5.62467 17.5416C4.46634 16.775 3.83301 15.725 3.83301 14.5833C3.83301 13.4416 4.46634 12.3833 5.62467 11.6083C8.12467 9.94998 12.1747 9.94998 14.658 11.6083C15.808 12.375 16.4497 13.425 16.4497 14.5666C16.4497 15.7083 15.8163 16.7666 14.658 17.5416C13.408 18.375 11.7747 18.7916 10.1413 18.7916ZM6.31634 12.6583C5.51634 13.1916 5.08301 13.875 5.08301 14.5916C5.08301 15.3 5.52467 15.9833 6.31634 16.5083C8.39134 17.9 11.8913 17.9 13.9663 16.5083C14.7663 15.975 15.1997 15.2916 15.1997 14.575C15.1997 13.8666 14.758 13.1833 13.9663 12.6583C11.8913 11.275 8.39134 11.275 6.31634 12.6583Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/userLogo.49dadf0827c67c7a950850d5db4585b4.svg";
export { ForwardRef as ReactComponent };